import * as tslib_1 from "tslib";
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { UsersApi } from './api/users-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./api/users-api.service";
import * as i2 from "../../../../../../@fuse/components/progress-bar/progress-bar.service";
var UsersService = /** @class */ (function () {
    function UsersService(api, fuseProgressBarService) {
        this.api = api;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    UsersService.prototype.loadData = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.api
                        .listUsers({
                        orderBy: options.orderBy,
                        limit: options.limit,
                        offset: options.offset,
                        where: where
                    })
                        .toPromise()
                        .then(function (page) {
                        _this.fuseProgressBarService.hide();
                        return {
                            items: page.items,
                            totalCount: page.totalCount,
                            filtered: Boolean(!!where.name_contains || where.archived !== false || !!where.email_contains || !!where.type_in || !!where.role_in)
                        };
                    })];
            });
        });
    };
    UsersService.prototype.save = function (id, input) {
        if (id) {
            return this.api.updateUser(id, input);
        }
        return this.api.createUser(input);
    };
    UsersService.prototype.archivedUser = function (id) {
        return this.api.archiveUser(id);
    };
    UsersService.prototype.unarchiveUser = function (id) {
        return this.api.unarchiveUser(id);
    };
    UsersService.prototype.setUserPassword = function (id, input) {
        return this.api.setUserPassword(id, input);
    };
    UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.UsersApi), i0.ɵɵinject(i2.FuseProgressBarService)); }, token: UsersService, providedIn: "root" });
    return UsersService;
}());
export { UsersService };
